import { combineReducers } from 'redux'
import onboardingReducer from './modules/onboarding/reducer'
import authReducer from './modules/auth/reducer'
import dashboardReducer from './modules/dashboard/reducer'
import adminDashboardReducer from './modules/adminDashboard/reducer'
import templateReducer from './modules/template/reducer'
import companyReducer from './modules/company/reducer'
import companyCardsReducer from './modules/companyCards/reducer'
import companyPaymentsReducer from './modules/companyPayments/reducer'
import companyPlanningRecordLettersReducer from './modules/companyPlanningRecordLetters/reducer'
import companyPlanningRecordReducer from './modules/companyPlanningRecord/reducer'
import planningRecordsReducer from './modules/planningRecords/reducer'
import planningRecordReducer from './modules/planningRecord/reducer'
import deadLetterEventsReducer from './modules/deadLetterEvents/reducer'
import templatesPendingReviewReducer from './modules/templatesPendingReivew/reducer'

const reducers = {
  onboarding: onboardingReducer,
  auth: authReducer,
  dashboard: dashboardReducer,
  adminDashboard: adminDashboardReducer,
  template: templateReducer,
  company: companyReducer,
  templatesPendingReview: templatesPendingReviewReducer,
  companyCards: companyCardsReducer,
  companyPayments: companyPaymentsReducer,
  companyPlanningRecordLetters: companyPlanningRecordLettersReducer,
  companyPlanningRecord: companyPlanningRecordReducer,
  planningRecords: planningRecordsReducer,
  planningRecord: planningRecordReducer,
  deadLetterEvents: deadLetterEventsReducer,
}
export const reducer = combineReducers(reducers)
